import { FC } from "react";
import { Tr, Td, Text, Spinner, Container } from "@chakra-ui/react";
import { useUserList, useRedirect } from "../../hooks";
import { column } from "../../helpers";
import { FuncButton } from "../../../customComponents/components/FuncButton";
import { TableHead } from "../TableHead";
import dayjs from "dayjs";

export const TableUsers: FC = () => {
  const { userList, loading } = useUserList();
  const { redirectToEdit } = useRedirect();

  if (loading) {
    return (
      <Container height="calc(100vh - 240px)">
        <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
      </Container>
    );
  }

  return (
    <TableHead column={column} isPage>
      {userList.map(
        ({ id, phone, username, confirmed, security_check, disabled, name, createdAt }) => (
          <Tr key={id}>
            <Td>
              <Text fontSize="sm" color="#121419">
                {id}
              </Text>
            </Td>
            <Td>
              <Text fontSize="sm" color="#121419">
                {dayjs(createdAt).format('HH:mm:ss DD.MM.YYYY')}
              </Text>
            </Td>
            <Td>
              <Text fontSize="sm" color="#121419">
                {name}
              </Text>
            </Td>
            <Td>
              <Text fontSize="sm" color="#121419">
                {phone}
              </Text>
            </Td>
            <Td>
              <Text fontSize="sm" color={confirmed > 0 ? "#121419" : "#A6A8AE"}>
                {confirmed}
              </Text>
            </Td>
            <Td>
              <Text
                fontSize="sm"
                fontWeight={"700"}
                color={
                  disabled === "1"
                    ? "#D77E59"
                    : security_check > 0
                    ? "#56AB6E"
                    : "#7D8DB5"
                }
              >
                {(() => {
                  console.log("id, security_check", id, security_check);
                  if (security_check == "pending") {
                    return "Ожидает";
                  }
                  if (security_check == "1") {
                    return "Пройдена";
                  }
                  if (security_check == "blocked") {
                    return "Заблокирован";
                  }
                  return "Ожидает";
                })()}
                {/* {disabled === "1"
                  ? "Заблокирован"
                  : security_check
                  ? "Пройдено"
                  : "Ожидает"} */}
              </Text>
            </Td>
            <Td isNumeric>
              <FuncButton
                onClick={() => redirectToEdit(id)}
                disabled={username === "admin"}
              >
                Редактировать
              </FuncButton>
            </Td>
          </Tr>
        )
      )}
    </TableHead>
  );
};
